var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TwoColumnsPageContainer',{attrs:{"side-top":"contact"}},[_vm._t("side",null,{"slot":"side"}),_vm._v(" "),_vm._t("body",null,{"slot":"body"}),_vm._v(" "),_c('template',{slot:"footer"},[_vm._t("before-disclaimer"),_vm._v(" "),_c('div',{staticClass:"my-16"},[_c('SellDisclaimer',{attrs:{"evaluation":!_vm.cityName}})],1)],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }